import { render, staticRenderFns } from "./Cursor.vue?vue&type=template&id=0c81d49b&"
import script from "./Cursor.vue?vue&type=script&lang=js&"
export * from "./Cursor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports